export const initialHomeState = () => ({
  fetchUserDetailsLoading: false,
  fetchUserDetailsFailure: false,
  fetchUserDetailsLoaded: false,
  details: null
});
